import React from 'react';
import { useTranslation } from 'react-i18next';

const LegacyVaultTrustBuilders: React.FC = () => {
    const { t } = useTranslation();
    const trustElements = [
        {
            title: t('lv_page.trust.backed_by'),
            description:t('lv_page.trust.were_committed_to'),
        },
        {
            title: t('lv_page.trust.free_obituary_template'),
            description: t('lv_page.trust.get_started_with'),
            link: '/assets/documents/obituary-template.pdf',
        },
        // {
        //     title: 'Estate attorney partner directory',
        //     description: 'Connect with trusted legal professionals in your area',
        // },
    ];

    const handleDownloadClick = () => {
        window.open(trustElements[1].link, '_blank');
    };

    const handleDirectoryClick = () => { };

    return (
        <section className="overflow-x-hidden py-12 lg:py-16">
            <div className="relative mx-auto max-w-[1142px] px-4">
                <div className="mx-auto pb-14 text-center lg:w-2/3 lg:pb-24">
                    <h2 className="mb-5 text-[26px]/7 font-bold text-green-700 dark:text-white">{t('lv_page.trust.title')}</h2>
                    <p className="text-lg md:text-xl">{t('lv_page.trust.subtitle')}</p>
                </div>

                <div className="grid gap-8 lg:grid-cols-3">
                    {trustElements.map((element, index) => (
                        <div
                            key={index}
                            className="group relative rounded-xl border border-green-200 bg-white p-8 text-center transition-all duration-300 hover:border-green-300 hover:shadow-lg dark:border-green-800 dark:bg-dark dark:hover:border-green-700"
                            data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-delay={index * 200}
                        >
                            <h3 className="mb-4 text-xl font-bold text-green-700 dark:text-white">{element.title}</h3>
                            <p className="mb-6 text-gray-600 dark:text-gray-300">{element.description}</p>

                            {index === 1 && (
                                <button
                                    onClick={handleDownloadClick}
                                    className="group relative inline-flex items-center gap-2.5 rounded-lg bg-primary px-6 py-3 font-semibold text-white transition-all duration-300 hover:bg-primary/90 dark:bg-primary dark:hover:bg-primary/90"
                                >
                                    <span>{t('lv_page.trust.download_template')}</span>
                                    <span className="relative start-0 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/20 duration-300 group-hover:start-1">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path d="M6 1V9M6 9L3 6M6 9L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            )}

                            {index === 2 && (
                                <button
                                    onClick={handleDirectoryClick}
                                    className="group relative inline-flex items-center gap-2.5 rounded-lg bg-primary px-6 py-3 font-semibold text-white transition-all duration-300 hover:bg-primary/90 dark:bg-primary dark:hover:bg-primary/90"
                                >
                                    <span>{t('lv_page.trust.view_directory')}</span>
                                    <span className="relative start-0 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/20 duration-300 group-hover:start-1">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path d="M2 6H10M10 6L7 3M10 6L7 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LegacyVaultTrustBuilders;
